import styled from 'styled-components';

export const TestCycleTestCasesListTabStyled = styled.div`
  width: 100%;

  /** reset global styling */
  table {
    margin: 0;
  }
`;

export const TestCycleTestCasesListIssuesCellStyled = styled.div`
  width: 400px;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

export const TestCycleAlignRowStyled = styled.div`
  display: flex;
  align-items: center;
  min-height: 32px;
`;

export const TestCycleUserPickerWrapper = styled.div`
  width: 100%;
  max-width: 200px;
`;

export const NoPermissionToViewTestCaseWrapper = styled.div`
  margin-left: -4px;
`;

export const TestCycleDetailsActionsStyled = styled.div`
  width: 100%;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
`;

export const TestCaseActionsWrapperStyled = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const CloseOpenWrapper = styled.div`
  display: flex;
  align-items: center;
`;
